var _path, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHkid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_25791",
    "data-name": "Group 25791",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.331,
    height: 17.227,
    viewBox: "0 0 24.331 17.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37349",
    "data-name": "Path 37349",
    d: "M-71.178,19.689h6.054s-.148,1.328,0-.221-.074-2.658-.591-3.1a3.1,3.1,0,0,0-1.993-1.107,4.568,4.568,0,0,0-2.214.148c-.3.221-.517-.074-.813.959s-.959,1.7-.812,2.289A5.591,5.591,0,0,0-71.178,19.689Z",
    transform: "translate(75.371 -6.498)",
    fill: "#f63"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 1.884,
    cy: 1.884,
    r: 1.884,
    transform: "translate(5.337 4.59)",
    fill: "#ffb299"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25790",
    "data-name": "Group 25790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37350",
    "data-name": "Path 37350",
    d: "M-73.551,22.4a2.4,2.4,0,0,1-2.4-2.4V7.572a2.4,2.4,0,0,1,2.4-2.4h19.536a2.4,2.4,0,0,1,2.4,2.4V20a2.4,2.4,0,0,1-2.4,2.4Zm0-15.984A1.155,1.155,0,0,0-74.7,7.572V20a1.155,1.155,0,0,0,1.154,1.154h19.536A1.156,1.156,0,0,0-52.86,20V7.572a1.156,1.156,0,0,0-1.155-1.154Zm1.776,12.432a.622.622,0,0,1-.622-.622V16.9a3.734,3.734,0,0,1,1.584-3.041l.247-.175-.2-.222a2.8,2.8,0,0,1-.739-1.891,2.844,2.844,0,0,1,2.842-2.841,2.844,2.844,0,0,1,2.842,2.842,2.8,2.8,0,0,1-.738,1.889l-.206.223.248.175A3.733,3.733,0,0,1-64.937,16.9v1.331a.623.623,0,0,1-.622.622Zm3.108-4.44A2.49,2.49,0,0,0-71.153,16.9v.71h4.973V16.9A2.49,2.49,0,0,0-68.667,14.41Zm0-4.44a1.6,1.6,0,0,0-1.6,1.6,1.6,1.6,0,0,0,1.6,1.6,1.6,1.6,0,0,0,1.6-1.6A1.6,1.6,0,0,0-68.667,9.97Z",
    transform: "translate(75.948 -5.175)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37351",
    "data-name": "Path 37351",
    d: "M-59.984,20.617A.623.623,0,0,1-60.606,20a.622.622,0,0,1,.622-.622h6.216a.623.623,0,0,1,.622.622.623.623,0,0,1-.622.622Z",
    transform: "translate(73.926 -7.047)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37352",
    "data-name": "Path 37352",
    d: "M-59.984,15.724a.623.623,0,0,1-.622-.622.623.623,0,0,1,.622-.622h6.216a.623.623,0,0,1,.622.622.623.623,0,0,1-.622.622Z",
    transform: "translate(73.926 -6.402)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37353",
    "data-name": "Path 37353",
    d: "M-59.984,10.83a.623.623,0,0,1-.622-.622.622.622,0,0,1,.622-.622h6.216a.623.623,0,0,1,.622.622.623.623,0,0,1-.622.622Z",
    transform: "translate(73.926 -5.757)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHkid);
export default __webpack_public_path__ + "static/media/icon-hkid.06bc2add012719a8fba64ede3ce238a5.svg";
export { ForwardRef as ReactComponent };